module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-switch"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Switch")]), _vm._v(" "), _c('div', {
    staticClass: "page-part page-switch-padding"
  }, [_c('mt-switch', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }, [_c('label', {
    domProps: {
      "textContent": _vm._s(_vm.value1)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-part page-switch-padding"
  }, [_c('mt-switch', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  }, [_c('label', {
    domProps: {
      "textContent": _vm._s(_vm.value4)
    }
  })])], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": '选项 ' + _vm.value2
    }
  }, [_c('mt-switch', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": '选项 ' + _vm.value3
    }
  }, [_c('mt-switch', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-786d23ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/switch.vue
// module id = 301
// module chunks = 0